<template>
  <v-card flat class="pa-6">
    <v-card-title class="text-h6 primary--text mb-6">
      {{ $t("login_and_phone_settings") }}
    </v-card-title>

    <v-card-text v-if="gameConfig">
      <!-- اگر loginConfig در schema وجود داشته باشد -->
      <div v-if="Object.keys(loginSchema).length > 0" class="mb-6">
        <v-switch
          v-model="gameConfig.login.askPhone"
          :label="$t('ask_phone_after_game')"
          inset
          color="primary"
          hint="اگر فعال باشد، پس از پایان بازی فرم شماره نمایش داده می‌شود"
          persistent-hint
        />

        <v-expand-transition>
          <v-row v-if="gameConfig.login.askPhone" dense>
            <!-- متن درخواست شماره -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="gameConfig.login.promptText"
                :label="$t('phone_prompt_text')"
                outlined
                dense
                placeholder="لطفا شماره موبایل خود را وارد کنید"
                hint="متن بالای فیلد شماره"
                persistent-hint
              />
            </v-col>

            <!-- متن دکمه ثبت -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="gameConfig.login.submitText"
                :label="$t('submit_button_text')"
                outlined
                dense
                placeholder="ثبت"
                hint="متن دکمه تایید شماره"
                persistent-hint
              />
            </v-col>

            <!-- لوگو (اختیاری) -->
            <v-col cols="12" v-if="loginSchema.logo">
              <h5 class="mb-3 primary--text">{{ $t("login_dialog_logo") }}</h5>
              <pic-selector
                v-model="gameConfig.login.logoUrl"
                one-pic
                single
                :default-cat-name="$t('login_logo')"
                accept="image/png,image/jpeg"
              />
            </v-col>
          </v-row>
        </v-expand-transition>
      </div>

      <!-- اگر loginConfig تعریف نشده باشد -->
      <v-alert v-else type="info" text prominent class="mb-4">
        تنظیمات ورود و شماره تلفن برای این نوع بازی تعریف نشده است.
      </v-alert>

      <!-- پیام‌های متنی مرتبط (از textsConfig) -->
      <v-row dense>
        <v-col cols="12" md="6" v-if="textsSchema.phoneTitle">
          <v-text-field
            v-model="gameConfig.texts.phoneTitle"
            :label="textsSchema.phoneTitle.label"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6" v-if="textsSchema.phonePlaceholder">
          <v-text-field
            v-model="gameConfig.texts.phonePlaceholder"
            :label="textsSchema.phonePlaceholder.label"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6" v-if="textsSchema.confirmBtn">
          <v-text-field
            v-model="gameConfig.texts.confirmBtn"
            :label="textsSchema.confirmBtn.label"
            outlined
            dense
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import { get, set } from "lodash";

export default {
  name: "TabLogin",
  components: { PicSelector },
  props: {
    value: { type: Object, required: true },
    schema: { type: Object, required: true },
  },
  computed: {
    gameConfig: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    loginSchema() {
      return this.schema?.loginConfig || {};
    },
    textsSchema() {
      return this.schema?.textsConfig || {};
    },
  },
  methods: {
    getSafeValue(path) {
      return get(this.gameConfig, path);
    },
    setSafeValue(path, val) {
      // Use Vue.set to ensure reactivity
      const parts = path.split('.');
      let obj = this.gameConfig;
      
      // Navigate to the parent object
      for (let i = 0; i < parts.length - 1; i++) {
        if (!obj[parts[i]]) {
          this.$set(obj, parts[i], {});
        }
        obj = obj[parts[i]];
      }
      
      // Set the final property
      this.$set(obj, parts[parts.length - 1], val);
      
      // همگام‌سازی با texts اگر لازم بود
      if (path === "login.promptText") {
        if (!this.gameConfig.texts) this.$set(this.gameConfig, 'texts', {});
        this.$set(this.gameConfig.texts, "phonePrompt", val);
      }
      if (path === "login.submitText") {
        if (!this.gameConfig.texts) this.$set(this.gameConfig, 'texts', {});
        this.$set(this.gameConfig.texts, "confirmBtn", val);
      }
      
      this.$emit("input", { ...this.gameConfig });
    },
  },
};
</script>
